export const isTimeOffEnabled =
  process.env.FEATURE_TIME_OFF === "false" ? false : true;
